<template>
  <div class="pulse-container" id="coaching-profile-details">
    <div>
      <h2 class="question-text brand-secondary">Complete Your Profile</h2>
    </div>
    <b-row>
      <div class="col-12 ">
        <b-form-group id="fieldset-6" label="Address" label-for="input-10">
          <b-form-input
            id="input-10"
            v-model="userProfile.address"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-6 ">
        <b-form-group id="fieldset-7" label="City" label-for="input-1">
          <b-form-input
            id="input-8"
            v-model="userProfile.city"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-6 ">
        <b-form-group id="fieldset-8" label="County" label-for="input-1">
          <b-form-input
            id="input-8"
            type="text"
            v-model="userProfile.county"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-6 ">
        <b-form-group id="fieldset-7" label="Postal Code" label-for="input-1">
          <b-form-input
            id="input-8"
            v-model="userProfile.postal_code"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-6 ">
        <b-form-group label="Next of Kin Full Name" label-for="nextKin">
          <b-form-input
            id="nextKin"
            v-model="userProfile.next_of_the_kin_full_name"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-6 ">
        <b-form-group label="Next of Kin Phone Number" label-for="nextKinPhone">
          <b-form-input
            id="nextKinPhone"
            type="number"
            v-model="userProfile.next_of_the_kin_phone"
            @keypress="phoneNumber($event)"
            trim
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-6 d-flex justify-content-center align-items-end">
        <b-button
          :disabled="!isFormValid"
          @click="updateUserDetails"
          class="save-btn"
          >Save</b-button
        >
      </div>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config/constants";

export default {
  name: "CoachingProfileDetails",
  props: ["userProfile"],
  computed: {
    isFormValid() {
      return (
        this.userProfile.address &&
        this.userProfile.city &&
        this.userProfile.county &&
        this.userProfile.postal_code &&
        this.userProfile.next_of_the_kin_full_name &&
        this.userProfile.next_of_the_kin_phone
      );
    }
  },
  methods: {
    phoneNumber(event) {
      if (this.userProfile.next_of_the_kin_phone.length > 14) {
        event.preventDefault();
      }
    },
    async updateUserDetails() {
      this.userProfile.image_url =
        "https://eu.ui-avatars.com/api/?name=Test+Test";
      const payload = {
        user_id: this.$store.getters.user_id,
        user_profile: this.userProfile
      };
      const res = await axios.post(
        config.api_env + "/application/api/u/user/update-user-profile",
        payload,
        config.options
      );
      if (res.data.success) {
        this.$emit("updateProfile");
      }
    }
  }
};
</script>

<style lang="less">
#coaching-profile-details {
  color: white !important;

  .question-text {
    font-size: 2.4rem;
    color: #fff;
    font-family: "PlusJakartaSansBold";
  }

  .form-group {
    font-size: 1.8rem;
    padding: 3px 5px !important;
  }

  .sub-header {
    padding: 15px;
    font-size: 1.8rem;
    font-weight: bold;
  }

  .pulse-container {
    background-color: #f8f8f8;
    min-height: 300px;
    border-radius: 40px;
  }

  .form-control {
    color: white !important;
    font-family: "PlusJakartaSansRegular";
    border: 0;
    background: transparent;
    border-bottom: 1px solid #e6e6e6;
    font-size: 1.6rem;
    max-width: 100% !important;
    line-height: 1.8rem;
    border-radius: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .form-control:focus {
    outline: none !important;
    border: unset;
    border-bottom: 1px solid #e83b75 !important;
    box-shadow: unset;
  }

  .form-control:disabled {
    color: #d6d6d6;
  }

  .custom-select {
    font-family: "PlusJakartaSansRegular";
    border: 0;
    background: transparent;
    border-bottom: 1px solid #e6e6e6;
    font-size: 14px;
  }

  .details-heading {
    padding: 0 15px;
    font-size: 1.8rem !important;
    font-family: "PlusJakartaSansRegular";
  }

  .custom-select:focus {
    outline: none !important;
    border: unset;
    border-bottom: 1px solid #e83b75 !important;
    box-shadow: unset;
  }

  .save-btn {
    background-color: #ed3a75;
    color: #fff;
    font-family: "PlusJakartaSansBold";
    font-size: 1.6rem;
    padding: 8px 24px;
    letter-spacing: 0;
    min-height: 40px;
    min-width: 120px;
    margin-bottom: 12px;

    &:hover {
      background-color: #ed3a76d9;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
